export default __webpack_public_path__ + "static/media/Card-BuyersEdge.69acf282.png";